import { useState, useRef } from "react";
import "./userinstructions.scss";
import instructionImg01 from "../../assets/Instructionpanel/Step_01.png";
import instructionImg02 from "../../assets/Instructionpanel/Step_02_a.png";
import instructionImg03 from "../../assets/Instructionpanel/Step_02_b.png";
import instructionImg04 from "../../assets/Instructionpanel/ext_home.png";
import instructionImg05 from "../../assets/Instructionpanel/camera_inst.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs, FreeMode } from "swiper";
import "swiper/scss";
import "swiper/scss/navigation";
import "swiper/scss/effect-creative";
import "swiper/css/thumbs";
import { store } from "../../Components/Redux/store";
import { setInstructionFalse } from "../../Components/Redux/actions";

const InstructionCarousel = () => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const swiperRef = useRef();

  const instructionDetails = [
    {
      id: 1,
      img: instructionImg01,
      step: "Step 1/5",
    },
    {
      id: 2,
      img: instructionImg02,
      step: "Step 2/5",
    },
    {
      id: 3,
      img: instructionImg03,
      step: "Step 3/5",
    },
    {
      id: 4,
      img: instructionImg04,
      step: "Step 4/5",
    },
    {
      id: 5,
      img: instructionImg05,
      step: "Step 5/5",
    },
  ];

  return (
    <div id="carousel-div">
      <Swiper
        modules={[Navigation, Thumbs, FreeMode]}
        thumbs={{
          swiper: thumbsSwiper,
        }}
        navigation={true}
        onBeforeInit={(swiper) => {
          swiperRef.current = swiper;
        }}
      >
        <div>
          {instructionDetails.map((data, index) => (
            <SwiperSlide key={index}>
              <div
                key={data.id}
                className="d-flex align-items-center justify-content-center"
              >
                <div>
                  <img
                    className="swiper-image"
                    src={data.img}
                    height="227.21"
                    width="392"
                    alt=""
                  />
                </div>
              </div>
              <div className="row pt-1 text-left">
                <div className="col">
                  <p style={{ fontSize: "10px", fontStyle: "Archivo" }}>
                    {data.step}
                  </p>
                </div>
                <div className="col">
                  {data.id != 5 ? (
                    <p
                      style={{
                        fontSize: "10px",
                        fontStyle: "Archivo",
                        color: "#0C8AE6",
                        cursor: "pointer",
                      }}
                      onClick={() => swiperRef.current?.slideNext()}
                    >
                      Next &#x27A2;
                    </p>
                  ) : (
                    <p
                      style={{
                        fontSize: "10px",
                        fontStyle: "Archivo",
                        color: "#0C8AE6",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        store.dispatch(setInstructionFalse(false));
                        window.open("https://www.youtube.com", "_newYT");
                        window.location.reload();
                      }}
                    >
                      Continue to YouTube &#x27A2;
                    </p>
                  )}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </div>
      </Swiper>
    </div>
  );
};

export default InstructionCarousel;
